// extracted by mini-css-extract-plugin
module.exports = {"container":"sectionContainer_container__2lVzS","heading":"sectionContainer_heading__1EHsm","blue":"sectionContainer_blue__2EdJl"};